module.exports = __webpack_public_path__ + "static/media/nyc-hra.2b310c9d.png";